import React from 'react';
import PropTypes from 'prop-types';
import formatRupees from '../../utils/currency';
import useCopyId from '../../helpers/copyId';
import { CopySVG } from '../icons';

function PaymentCard({
  paymentDoneOn, totalPayable, paymentStatus, transactionId = '',
}) {
  const copyId = useCopyId();
  const formatedDate = new Date(Number(paymentDoneOn)).toLocaleString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
  // console.log(transactionId, 'fdkaljfadsl;fld');
  return (
    <>
      <h2 className="text-[22px] font-semibold mb-6">Payment Details</h2>
      <div className="w-full mx-auto p-6 rounded-lg border border-[#B8E5FF] shadow-sm bg-white mb-4 ">
        <div className="flex flex-col space-y-2">
          <div className="flex justify-between items-center">
            <div className="flex gap-1 items-baseline">
              <span className="text-[#334155] font-semibold text-sm md:text-base">Paid on:</span>
              <span className="text-sm md:text-base text-gray-800">{formatedDate}</span>
            </div>
            <div className={`flex gap-1 items-baseline ${
              // eslint-disable-next-line no-nested-ternary
              paymentStatus === 'paid'
                ? 'text-green-600'
                : paymentStatus === 'scheduled'
                  ? 'text-[#9D6D06]'
                  : 'text-[#FF675A]'
            }`}
            >
              <span className="font-semibold text-sm md:text-base">Status:</span>
              <span
                className="text-sm md:text-base font-medium"
              >
                {String(paymentStatus).charAt(0).toUpperCase() + String(paymentStatus).slice(1)}
              </span>
            </div>
          </div>

          <div className="flex justify-between items-center">

            <div className="flex gap-1 items-baseline">
              <span className="text-[#334155] font-semibold text-sm md:text-base">Amount:</span>
              <span className="text-sm md:text-base font-medium text-gray-800">
                {formatRupees(totalPayable)}
              </span>
            </div>

            {/* <div className="flex gap-1 items-baseline">
              <span className="text-[#334155] font-semibold text-sm md:text-base">Paid via:</span>
              <span className=" text-sm md:text-base text-gray-800">Credit Card</span>
            </div> */}
          </div>

          <div className="flex justify-between items-center">
            <div className="flex gap-1 items-baseline">
              <span className="text-[#334155] font-semibold text-sm md:text-base">Payment Ref ID:</span>
              <span className="text-sm md:text-base text-gray-800">
                {transactionId.length > 10 ? `${transactionId.slice(0, 10)}...` : transactionId}

              </span>
            </div>
            <div>
              { /* TODO SHOW COPIED */}
              <button
                type="button"
                onClick={(e) => {
                  copyId(e, { id: transactionId, message: 'Transaction ID has been successfully copied' });
                }}
                className="text-white rounded-full h-7 w-7 flex items-center justify-center"
              >
                <CopySVG />
              </button>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}
PaymentCard.propTypes = {
  paymentDoneOn: PropTypes.string.isRequired,
  paymentStatus: PropTypes.string.isRequired,
  totalPayable: PropTypes.string.isRequired,
  transactionId: PropTypes.string.isRequired,
};
export default PaymentCard;
